export const PAYROLL_STATUS = Object.freeze({
  created: {
    title: 'In Progress',
    color: '#3b82f6'
  },
  completed: {
    title: 'In Review',
    color: '#6C69FF'
  },
  verified_completed: {
    title: 'Verified',
    color: '#33dfcf'
  },
  sign_completed: {
    title: 'Awaiting Payment',
    color: '#10b981'
  },
  paid: {
    title: 'Paid',
    color: '#10b981'
  }
})

export const ADJUSTMENT_STATUS = Object.freeze({
  initial: {
    title: 'Initial',
    color: '#3b82f6'
  },
  validated: {
    title: 'Validated',
    color: '#10b981'
  }
})

export const ASSOCIATE_STATUS = Object.freeze({
  initial: {
    title: 'Unverified',
    color: '#f59e0b'
  },
  started: {
    title: 'Started',
    color: '#3b82f6'
  },
  validated: {
    title: 'Verified',
    color: '#33dfcf'
  },
  signed: {
    title: 'Signed',
    color: '#10b981'
  },
  admin_signed: {
    title: 'Admin Signed',
    color: '#6C69FF'
  }
})

export const PAYROLL_MAPPING_KEYS = Object.freeze([
  'vacation',
  'sick',
  'holiday',
  'time_off',
  'discretionary',
  'non_discretionary'
])

export const INITIAL_PAYROLL_PAY_CODE_MAPPINGS = Object.freeze({
  vacation: null,
  sick: null,
  holiday: null,
  time_off: null,
  discretionary: null,
  non_discretionary: null
})

export const PAYROLL_EARNING_TITLE_GROUPS = Object.freeze([
  {
    label: 'Penalty',
    options: [
      { key: 'meal_break', title: 'Meal Break' },
      { key: 'rest_break', title: 'Rest Break' },
      { key: 'split_shift', title: 'Split Shift' }
    ]
  },
  {
    label: 'Training',
    options: [
      { key: 'training_regular', title: 'Training Regular' },
      { key: 'training_overtime', title: 'Training Overtime' },
      { key: 'training_double_time', title: 'Training Double Time' }
    ]
  },
  {
    label: 'Premium Pay',
    options: [
      { key: 'shift_differential_am', title: 'Shift Differential AM' },
      { key: 'shift_differential_pm', title: 'Shift Differential PM' },
      { key: 'shift_differential_noc', title: 'Shift Differential NOC' },
      { key: 'holiday_bonus', title: 'Holiday Premium' },
      { key: 'weekend_bonus', title: 'Special Week Day Bonus' },
      { key: 'perfect_attendance', title: 'Perfect Attendance Bonus' },
      { key: 'supervisor_position_bonus', title: 'Supervisor Position Bonus' },
      { key: 'hire_bonus', title: 'Hire Bonus' },
      { key: 'retention_bonus', title: 'Retention Bonus' },
      { key: 'emergency_on_call_bonus', title: 'Emergency On-Call Bonus' },
      { key: 'rating_bonus', title: 'Rating Bonus' },
      { key: 'referral_bonus', title: 'Referral Bonus' }
    ]
  },
  {
    label: 'Advance',
    options: [{ key: 'advance', title: 'Advance' }]
  },
  {
    label: 'Time Off',
    options: [
      { key: 'pay_code_hours_time_off', title: 'Time Off' },
      { key: 'pay_code_hours_vacation', title: 'Vacation' },
      { key: 'pay_code_hours_sick', title: 'Sick' }
    ]
  },
  {
    label: 'Holiday',
    options: [{ key: 'pay_code_hours_holiday', title: 'Holiday Hours' }]
  },
  {
    label: 'Bonus',
    options: [
      { key: 'pay_code_amount_bonus', title: 'Discretionary Bonus' },
      { key: 'pay_code_amount_compensation', title: 'Non-Discretionary Bonus' }
    ]
  }
])

export const INITIAL_STATE = {
  payrolls: [],

  metrics: {},

  adjustments: [],

  adjustmentsShifts: {},
  adjustmentsShiftsLoading: {},

  payPeriods: [],

  activePayroll: null,

  shifts: {
    paid: {},
    ready_to_pay: {},
    problematic: {}
  },

  paymentRequests: {},

  calculations: [],

  validationAssociates: {},
  signedAssociates: {},
  unsignedAssociates: {},

  associateShifts: {},
  associatePayments: {},
  associateCalculations: [],

  scopePresets: [],
  scopePreset: null,
  scopeGlobal: null,
  premiumPayRules: [],
  payCodeMappings: {
    ...INITIAL_PAYROLL_PAY_CODE_MAPPINGS
  }
}
